
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySparConeDown as ObiBuoySparConeDownElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spar-cone-down.js';
 
 
 

 
 export const ObiBuoySparConeDown = createComponent({
   react: React,
   tagName: 'obi-buoy-spar-cone-down',
   elementClass: ObiBuoySparConeDownElement,
   events: {
     
   }
  });
 
 